/*global google*/
import React, { Component } from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  DirectionsRenderer
} from "react-google-maps";

let GoogleMapExample =null
//const mapRef = React.useRef(null)
class Map extends Component {
  constructor(props){
    super(props);
    //console.log(props)
    this.state = {
      mapRef:null,
      directions: null,
      directionsRef:null,
      lat:this.props.lat,
      lng:this.props.lng,
      latF:this.props.latF,
      lngF:this.props.lngF
    };
    GoogleMapExample = withGoogleMap(props => (
     <GoogleMap
       defaultCenter={{ lat: Number(this.state.lat), lng: Number(this.state.lng) }}
       defaultZoom={16}
       onDragend={this.handleBoundsChange}
       ref={this.state.mapRef}

     >
       <DirectionsRenderer
         directions={this.state.directions}
         options={{draggable:true}}
         ref={(r) => this.state.directionsRef = r}
         onDirectionsChanged={this.getDirections}
       />
     </GoogleMap>
   ));
  }

  componentDidUpdate(){

  }
  componentDidMount() {
    //console.log("dddddd")
    const directionsService = new google.maps.DirectionsService();
    //var directionsRenderer = new google.maps.DirectionsRenderer();
    //directionsRenderer.setMap(this.state.directionsRef);
    const origin = { lat: Number(this.state.lat), lng: Number(this.state.lng) };
    const destination = { lat: Number(this.state.latF), lng: Number(this.state.lngF) };

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          //console.log(result.routes[0])
          //DirectionsRenderer.setDirections(result);
          //setDirections(result);
          this.setState({
            directions: result
          },()=>{
            this.getValueKilometros(Number(result.routes[0].legs[0].distance.value),
            Number(this.state.directionsRef.getDirections().routes[0].legs[0].end_location.lat())
            ,Number(this.state.directionsRef.getDirections().routes[0].legs[0].end_location.lng()))
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }
  //setDirections=()=>{

  //}
   getDirections=()=> {
     //console.log(this.state.directionsRef.getDirections());
     this.getValueKilometros(Number(this.state.directionsRef.getDirections().routes[0].legs[0].distance.value),
       Number(this.state.directionsRef.getDirections().routes[0].legs[0].end_location.lat()),
       Number(this.state.directionsRef.getDirections().routes[0].legs[0].end_location.lng()))
   }
   getValueKilometros =(value,lt,ln)=>{
    this.props.getValueKilometros(value,lt,ln)
   }
  render() {
    return (
      <React.Fragment>
        <GoogleMapExample
          containerElement={<div style={{ height: `100%`, width: "100%" }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </React.Fragment>
    );
  }
}

export default Map;
